import { useQuery } from '@tanstack/react-query';
import * as utils from '../lib/utils';

export function useLineItems(query = '', userData = null) {
  console.log("useLineItems: query", query, "userData", userData?.role);

  return useQuery({
    queryKey: ['lineItems', query, userData?.role],
    queryFn: async () => {
      if (!userData) {
        console.log('No user data available, returning empty array');
        return [];
      }

      console.log('Fetching fresh line items data from API with user role:', userData?.role);
      const response = await utils.getLineItems(query);
      return response.data.lineItems;
    },
    enabled: !!userData,
  });
}
